import { render, staticRenderFns } from "./init-bsj-sms-modal.vue?vue&type=template&id=5c22e2ca"
import script from "./init-bsj-sms-modal.vue?vue&type=script&lang=js"
export * from "./init-bsj-sms-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports